// extracted by mini-css-extract-plugin
export default {"wrapper":"copy-module--wrapper--5f145","dot":"copy-module--dot--aab22","empty":"copy-module--empty--45908","indexConfig":"copy-module--indexConfig--641e7"};